exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company__logo {\r\n  max-width: 150px;\r\n}\r\n.company_address {\r\n    display: inline-table;\r\n   /*position: absolute;*/\r\n   padding: 15px;\r\n   line-height: 20px;\r\n   padding-top: 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/container/product-details/product-description/product-description.component.css
// module id = ../../../../../src/app/container/product-details/product-description/product-description.component.css
// module chunks = main